import { Tooltip as TooltipAD, type TooltipProps } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

export type TooltipProperties = Omit<ComponentProps<typeof TooltipAD>, 'css'>;

import styles from './tooltip.module.css';

const Tooltip = ({ children, classNames, title, ...rest }: TooltipProperties) => {
  const { t } = useTranslation();

  return (
    <TooltipAD
      classNames={
        typeof classNames === 'function'
          ? (info: { props: TooltipProps }) => {
              const resolvedClassNames = classNames(info);

              return {
                ...resolvedClassNames,
                container: cn(resolvedClassNames?.container, styles.container),
              };
            }
          : {
              ...classNames,
              container: cn(classNames?.container, styles.container),
            }
      }
      title={typeof title === 'string' ? t(title) : title}
      {...rest}
    >
      {typeof children === 'string' ? t(children) : children}
    </TooltipAD>
  );
};

export default Tooltip;
